module.exports = __webpack_public_path__ + "assets/img/aboutUS-module6-2.209d3ffd.jpg";